import React from "react";

import { Button, Drawer, Stack } from "@mui/material";
import { SimpleHeadMui } from "components";
import { IInvestmentDetailField } from "store/types";

import { CompanyField } from "./components/CompanyField";
import { useAddCompanyHook } from "./hooks/use-add-company-hook";

interface AddCompanyDrawerProps {
  open: boolean;
  onClose: () => void;
  refetch: () => void;
  columns: IInvestmentDetailField[];
}

export const AddCompanyDrawer: React.FC<AddCompanyDrawerProps> = ({ open, onClose, refetch, columns }) => {
  const { handleSubmit, handleFieldChange, getFieldByColumnId, handleClose, formik } = useAddCompanyHook(
    columns,
    onClose,
    refetch
  );

  return (
    <Drawer
      sx={{ ".MuiPaper-root": { borderRadius: "0 20px 20px 0" } }}
      anchor="left"
      open={open}
      onClose={handleClose}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          overflow: "hidden",
          borderRadius: "0 12px 12px 0",
          width: "519px",
          height: "100%"
        }}
      >
        <SimpleHeadMui onIconClick={handleClose}>Add Manually Underlying Assets</SimpleHeadMui>
        <Stack sx={{ p: "30px", gap: "24px", flexGrow: 1, overflow: "auto" }} alignItems="stretch">
          {columns.map((column) => (
            <CompanyField
              key={column.id}
              column={column}
              field={getFieldByColumnId(column.id)}
              onFieldChange={handleFieldChange}
              formik={{
                values: formik.values,
                errors: formik.errors,
                touched: formik.touched
              }}
            />
          ))}
        </Stack>
        <Stack
          direction="row"
          sx={{
            boxShadow: "0 -1px 5px 1px rgba(0,0,0,.08)",
            p: "18px 30px",
            justifyContent: "flex-end",
            alignItems: "center"
          }}
        >
          <Stack direction="row" sx={{ alignItems: "center", gap: "18px" }}>
            <Button onClick={handleClose}>Cancel</Button>
            <Button type="submit" variant="contained" sx={{ bgcolor: "#071F35" }}>
              Add
            </Button>
          </Stack>
        </Stack>
      </form>
    </Drawer>
  );
};
